import {
    LoggerResponse,
} from '../Loggers.types'

export enum UpdateField {
    RentingCompany = 'RentingCompany',
    LoggerStatus = 'LoggerStatus',
    DestinationLocation = 'DestinationLocation',
}

export type LoggerBatchUpdateFormValues = LoggerResponse & {
    update: UpdateField;
    updateTo: any
}
